<div class="loginCard"
    style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%; background-color: #f0f0f0;">
    <div class="card"
        style="padding: 2%; max-width: 50%; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5); border-radius: 20px; background: white;">
        <div class="container">
            <div class="card-header-wrapper">
                <div style="display: flex; justify-content: center;">
                    <img [src]="logotipo" alt="Logo" style="max-width: 60%; height: auto; margin-top: 2%;">
                </div>


                <div class="card-component">
                    <form class="k-form k-form-horizontal"
                        style="max-width: 90%; width: 90%; margin: auto; margin-top: 2%;" [formGroup]="formGroup"
                        (keydown.enter)="onSubmit($event)">

                        <fieldset class="k-form-fieldset">

                            <!-- Div para manter os campos de entrada alinhados -->
                            <div style="display: flex; flex-direction: column; width: 100%; gap: 10px;">

                                <!-- Campo de email -->
                                <kendo-formfield orientation="horizontal" style="width: 100%;">
                                    <div style="display: flex; flex-direction: column; width: 100%;">
                                        <kendo-label class="k-label" [for]="login"
                                            text="{{ this.customMsgService.translate('email') }}">
                                        </kendo-label>
                                        <div style="width: 130%;">
                                            <kendo-textbox formControlName="login" #login required style="width: 100%;">
                                            </kendo-textbox>
                                        </div>
                                    </div>
                                </kendo-formfield>


                                <!-- Campo de Password -->
                                <kendo-formfield orientation="horizontal" style="width: 100%;">
                                    <div style="display: flex; flex-direction: column; width: 100%;">
                                        <kendo-label class="k-label" [for]="password">
                                            {{ this.customMsgService.translate('password') }}
                                        </kendo-label>
                                        <div style="width: 130%;">
                                            <kendo-textbox formControlName="password" #password="kendoTextBox" required
                                                style="width: 100%;">
                                                <ng-template kendoTextBoxSuffixTemplate>
                                                    <kendo-textbox-separator></kendo-textbox-separator>
                                                    <button kendoButton fillMode="flat" icon="eye"
                                                        (click)="selectedChange()"></button>
                                                </ng-template>
                                            </kendo-textbox>
                                        </div>

                                        <!-- Forgot Password -->
                                        <div
                                            style="display: flex; justify-content: flex-end; width: 130%; margin-top: 5px;">
                                            <button class="forgetPW" kendoButton (click)="forgotPassword()"
                                                fillMode="flat">
                                                {{ this.customMsgService.translate('forgotPassword') }}
                                            </button>
                                        </div>
                                    </div>
                                </kendo-formfield>
                            </div>


                            <div style="display: flex; justify-content: center; width: 100%;">
                                <button class="btnLogin" kendoButton (click)="onSubmit()" themeColor="primary"
                                    [disabled]="!formGroup.valid">
                                    Login
                                </button>
                            </div>


                        </fieldset>

                    </form>
                </div>
            </div>
        </div>